import { render, staticRenderFns } from "./WeeklyRankingView.vue?vue&type=template&id=72b66ea0&"
import script from "./WeeklyRankingView.vue?vue&type=script&lang=js&"
export * from "./WeeklyRankingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports